export default class CategoryListModel {
    categoryId: string | null | undefined;
    categoryText: string | null | undefined;

    static from(json: string): CategoryListModel {        
        return Object.assign(new CategoryListModel(), json);
    }
}
